<template>
  <v-row v-if="showCards" class="mb-2">
    <template v-if="loading">
      <v-col
        v-for="n in 3"
        :key="'skeleton-' + n"
        cols="12"
        md="4"
      >
        <v-skeleton-loader type="card" class="mx-auto" />
      </v-col>
    </template>
    <template v-else>
      <v-col
        v-for="card in cards"
        :key="card.key"
        cols="12"
        md="4"
      >
        <v-card
          class="skp-summary-card"
          :class="'accent-' + card.color"
          elevation="2"
        >
          <div class="skp-summary-card__accent" :style="{ background: card.gradient }" />
          <div class="skp-summary-card__body">
            <div
              class="skp-summary-card__icon"
              :style="{ background: card.iconBg, color: card.iconColor }"
            >
              <v-icon size="28" :color="card.iconColor">{{ card.icon }}</v-icon>
            </div>
            <div class="skp-summary-card__content">
              <div class="skp-summary-card__label">{{ card.label }}</div>
              <div class="skp-summary-card__value">{{ formatNumber(card.value) }}</div>
              <div class="skp-summary-card__subtitle">{{ card.subtitle }}</div>
            </div>
          </div>
        </v-card>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import MonitoringSKPService from '@/services/MonitoringSKPService'
import store from '@/store'

export default {
  name: 'SKPSummaryCards',

  data () {
    return {
      loading: false,
      summary: {
        skp: 0,
        skp_triwulan: 0,
        penilaian_tahunan: 0
      }
    }
  },

  computed: {
    tahun () {
      return parseInt(store.state.user.current.year, 10) || 0
    },

    showCards () {
      return this.tahun >= 2025
    },

    cards () {
      return [
        {
          key: 'skp',
          label: 'SKP Tahunan',
          subtitle: 'Pegawai yang membuat SKP tahunan',
          value: this.summary.skp,
          icon: 'mdi-file-document-edit-outline',
          color: 'indigo',
          iconColor: '#3949AB',
          iconBg: 'rgba(57, 73, 171, 0.12)',
          gradient: 'linear-gradient(180deg, #5C6BC0 0%, #3949AB 100%)'
        },
        {
          key: 'skp_triwulan',
          label: 'SKP Triwulan',
          subtitle: 'Pegawai yang membuat SKP triwulan',
          value: this.summary.skp_triwulan,
          icon: 'mdi-calendar-month-outline',
          color: 'teal',
          iconColor: '#00897B',
          iconBg: 'rgba(0, 137, 123, 0.12)',
          gradient: 'linear-gradient(180deg, #26A69A 0%, #00897B 100%)'
        },
        {
          key: 'penilaian_tahunan',
          label: 'Penilaian Tahunan',
          subtitle: 'Pegawai yang sudah memiliki nilai SKP tahunan',
          value: this.summary.penilaian_tahunan,
          icon: 'mdi-clipboard-check-outline',
          color: 'amber',
          iconColor: '#F9A825',
          iconBg: 'rgba(249, 168, 37, 0.14)',
          gradient: 'linear-gradient(180deg, #FFCA28 0%, #F9A825 100%)'
        }
      ]
    }
  },

  created () {
    if (this.showCards) {
      this.fetchSummary()
    }
  },

  methods: {
    formatNumber (value) {
      if (value === null || value === undefined) return '0'
      return Number(value).toLocaleString('id-ID')
    },

    fetchSummary () {
      this.loading = true
      MonitoringSKPService.getSummary()
        .then((response) => {
          const data = response.data && response.data.data
          if (data) {
            this.summary = {
              skp: data.skp || 0,
              skp_triwulan: data.skp_triwulan || 0,
              penilaian_tahunan: data.penilaian_tahunan || 0
            }
          }
        })
        .catch((err) => {
          const message = (err.response && err.response.data && err.response.data.message)
            ? err.response.data.message
            : (err.message || 'Gagal memuat ringkasan SKP')
          store.commit('snackbar/setSnack', { message: message, color: 'error' })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="css" scoped>
.skp-summary-card {
  position: relative;
  overflow: hidden;
  border-radius: 12px !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  background: #fff;
}

.skp-summary-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
}

.skp-summary-card__accent {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
}

.skp-summary-card__body {
  display: flex;
  align-items: center;
  padding: 20px 20px 20px 24px;
  gap: 16px;
  min-height: 110px;
}

.skp-summary-card__icon {
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.skp-summary-card__content {
  flex: 1;
  min-width: 0;
}

.skp-summary-card__label {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #546E7A;
  margin-bottom: 4px;
}

.skp-summary-card__value {
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
  color: #263238;
  letter-spacing: -0.02em;
}

.skp-summary-card__subtitle {
  font-size: 12px;
  color: #90A4AE;
  margin-top: 4px;
  line-height: 1.35;
}
</style>
